import * as XLSX from 'xlsx';

export function downloadZeussDemoXlsx() {
  const headers = [
    'Nome Completo',
    'CPF',
    'Telefone',
    'E-mail',
    'Limite Concedido',
  ];

  const ws = XLSX.utils.aoa_to_sheet([headers]);

  ws['!cols'] = [
    { wch: 30 },
    { wch: 14 },
    { wch: 16 },
    { wch: 28 },
    { wch: 18 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Modelo');

  XLSX.writeFile(wb, 'modelo-importacao-zeuss.xlsx');
}

export function downloadCampaingDemoXlsx() {
  const headers = [
    'CPF',
  ]

  const ws = XLSX.utils.aoa_to_sheet([headers]);

  ws['!cols'] = [
    { wch: 14 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Modelo');

  XLSX.writeFile(wb, 'modelo-importacao-campanha.xlsx');
}
